module.exports = __webpack_public_path__ + "img/slider_d02.55dccda.c25dfc38.png";